var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResDrivingMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13,
    cy: 12,
    r: 12,
    fill: "#F34F42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22686_357587)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 5,
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 6,
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9324 9.19293H13.9002C13.7345 8.88081 13.3934 8.66602 13 8.66602C12.6067 8.66602 12.2655 8.88081 12.0998 9.19293H11.0676C10.9383 9.19293 10.8334 9.29225 10.8334 9.41477C10.8334 9.5373 10.9383 9.63663 11.0676 9.63663H11.9933C11.9942 9.68637 11.9991 9.73517 12.0078 9.7828C11.5589 9.86902 11.2199 10.2457 11.2199 10.696V13.3027C11.2199 13.811 11.6517 14.2252 12.1861 14.2341V14.6006C12.1861 15.0043 12.5328 15.3327 12.9591 15.3327H13.041C13.4672 15.3327 13.814 15.0043 13.814 14.6006V14.2341C14.3483 14.2252 14.7802 13.8109 14.7802 13.3027V10.696C14.7802 10.2457 14.4412 9.869 13.9923 9.78278C14.0009 9.73515 14.0059 9.68635 14.0068 9.63661H14.9325C15.0618 9.63661 15.1667 9.53728 15.1667 9.41474C15.1667 9.29223 15.0618 9.19293 14.9324 9.19293ZM13 9.10972C13.2971 9.10972 13.5388 9.33861 13.5388 9.61997C13.5388 9.90134 13.2971 10.1302 13 10.1302C12.703 10.1302 12.4613 9.90134 12.4613 9.61997C12.4613 9.33861 12.703 9.10972 13 9.10972ZM13.3455 14.6006C13.3455 14.7596 13.2089 14.889 13.041 14.889H12.959C12.7911 14.889 12.6545 14.7596 12.6545 14.6006V13.4247C12.6545 13.2657 12.7911 13.1363 12.959 13.1363H13.041C13.2089 13.1363 13.3455 13.2657 13.3455 13.4247V14.6006ZM13.7964 10.2079C14.0805 10.2079 14.3117 10.4268 14.3117 10.696V13.3027C14.3117 13.5662 14.09 13.7815 13.814 13.7904V13.4247C13.814 13.0211 13.4672 12.6926 13.041 12.6926H12.959C12.5328 12.6926 12.1861 13.0211 12.1861 13.4247V13.7904C11.9101 13.7816 11.6883 13.5663 11.6883 13.3027V10.696C11.6883 10.4268 11.9195 10.2079 12.2036 10.2079H12.2077C12.3922 10.4305 12.6787 10.574 13 10.574C13.3213 10.574 13.6078 10.4305 13.7924 10.2079H13.7964V10.2079Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22686_357587",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22686_357587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22686_357587",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResDrivingMotor);
export default __webpack_public_path__ + "static/media/resDrivingMotor.110e2c44119878d4ccf0e3a0d96a4954.svg";
export { ForwardRef as ReactComponent };